import type { IconSvgObject } from './types';

const StrokeLeftIcon: IconSvgObject = [
  ["path", { d: "M7 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default StrokeLeftIcon;
